import React, { useEffect, useState } from "react";
import {
  loadAlert,
  loadAppCard,
  loadFavAlert,
  loadHideAlert,
  loadLinkAlert,
} from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import AlertConfirm from "components/ui/alert-confirm";
import AppCardDrawer from "components/ui/app-card-drawer";
import { openMagamartMall } from "assets/js/apphandle";
import { goLink } from "assets/js/common";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";
import AlertComplete from "components/ui/alert-complete";

const cookies = new Cookies();
export default function CommonComponent(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    alertOpen,
    appCardOpen,
    favAlertOpen,
    hideAlertOpen,
    linkAlert,
  } = useSelector((state) => state.top);
  const [drawerHigh, setDrawerHigh] = useState(false);
  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };
  
  const handleAlertOpen = (path) => {
    setRedirectPath(path);
    setOpen(true);
  };

  const handleAlertClose = () => {
    // setOpen(false);
    dispatch(loadAlert(false));
  };

  const handleFavAlertClose = () => {
    // setOpen(false);
    dispatch(loadFavAlert(false));
  };

  const handleHideAlertClose = () => {
    // setOpen(false);
    dispatch(loadHideAlert(false));
  };

  const handleLinkAlertClose = () => {
    dispatch(loadLinkAlert(""));
  };

  const goLogin = () => {
    history.push({
      pathname: "/login",
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
  };

  const goFav = () => {
    history.push({
      pathname: "/favorite-store",
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
  };

  window.appShakeHandle = () => {
    const accessToken = cookies.get("X-AUTH-TOKEN");
    if (accessToken) {
      const myDecodedToken = jwt_decode(accessToken);
      if (myDecodedToken.shakeYn == "Y") dispatch(loadAppCard(true));
    }
  };

  // TODO
  window.appGoPushUrlHandle = (os, url) => {
    if (url) history.push(url);
  };

  const goCheckLink = () => {
    if (linkAlert) {
      goLink(linkAlert);
      dispatch(loadLinkAlert(""));
    }
  };

  return (
    <>
      <AppCardDrawer
        open={appCardOpen}
        handleDrawerClose={() => {
          dispatch(loadAppCard(false));
        }}
        text={`앱카드 열기`}
        callback={() => {
          dispatch(loadAppCard(false));
        }}
      />
      <AlertConfirm
        open={alertOpen || false}
        handleAlertClose={handleAlertClose}
        text={`로그인이 필요한 서비스입니다.<br/>로그인 하시겠습니까?`}
        action={goLogin}
      />
      <AlertConfirm
        open={favAlertOpen || false}
        handleAlertClose={handleFavAlertClose}
        text={`등록된 단골 매장이 없습니다.<br/>단골매장 선택 화면으로 이동 하시겠습니까?`}
        action={goFav}
      />
      <AlertComplete
        open={hideAlertOpen || false}
        handleAlertClose={handleHideAlertClose}
        text={`서비스 준비중입니다.`}
        action={handleHideAlertClose}
      />
      <AlertConfirm
        open={linkAlert || false}
        handleAlertClose={handleLinkAlertClose}
        text={`외부로 연결되는 사이트입니다.<br/>브라우저로 실행하시겠습니까?`}
        action={goCheckLink}
      />
    </>
  );
}
